import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
import moment from "moment";
Vue.use(Vuex)
const state = {
    pingList: [],
    traceList: [],
    socketSystemStatus: [],
    socketUpdateTime: ""
}

const mutations = {
    SET_PING_DETAILS(state, pingData) {
        var tData = {};
        var parseData = pingData.message;
        if (Object.keys(state.pingList).length == 0) {
            tData[pingData.accountId + '-pingList'] = parseData;
            state.pingList = tData;
        } else {
            Vue.set(state.pingList, pingData.accountId + '-pingList', parseData);
        }
    },
    SET_TRACE_DETAILS(state, traceData) {
        var tData = {};
        var parseData = traceData.message;
        if (Object.keys(state.traceList).length == 0) {
            tData[traceData.accountId + '-traceList'] = parseData;
            state.traceList = tData;
        } else {
            Vue.set(state.traceList, traceData.accountId + '-traceList', parseData);
        }
    },
    SOCKET_SYSTEMSTATUSSOCK(state, data) {
        state.socketSystemStatus = JSON.parse(data)
    },
    CALL_SOCKET_UPDATE(state, data) {
        this._vm.$socket.client.emit('socket_system_status', data)
    },
    STOP_SOCKET_UPDATE(state, data) {
        this._vm.$socket.client.emit('socket_system_status', "stop");
    }
}

const actions = {
    fetchPingDetails({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/diagnostics/ping/true")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push("/dashboard");
                } else {
                    commit('SET_PING_DETAILS', response.data)
                }
            })
            .catch(error => console.log(error))
    },
    createPingModalSubmit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/diagnostics/ping/true', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fetchTraceRoute({
        commit
    }, authData) {
        Nprogress.start()
        axios.get("/diagnostics/trace_route/true")
            .then(response => {
                Nprogress.done()
                if (response.data.status == "redirect") {
                    router.push("/dashboard");
                } else {
                    commit('SET_TRACE_DETAILS', response.data)
                }
            })
            .catch(error => console.log(error))
    },
    createTraceRoute({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/diagnostics/trace_route/true', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }

                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    triggerSocket({
        commit,
        dispatch
    }, postData) {
        let data = postData;
        commit("CALL_SOCKET_UPDATE", data)
    },
    unsubscribeSocketEvent({
        commit,
        dispatch
    }, postData) {
        console.log("un suc ribe");
        commit("STOP_SOCKET_UPDATE")
    },
}

const getters = {
    getPingListGetters: state => {
        return state.pingList;
    },
    getTraceListGetters: state => {
        return state.traceList;
    },
    getSocketSystemStatusGetters: state => {
        return state.socketSystemStatus
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}